(function () {
  'use strict';
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }


  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Free shipping countdown: hides itself when the end time passes. */
  document.querySelectorAll('[data-ship-end],[data-ship-daily]').forEach(function (box) {
    var daily = box.hasAttribute('data-ship-daily');
    function nextMidnight() { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
    var end = daily ? nextMidnight() : Date.parse(box.getAttribute('data-ship-end'));
    if (isNaN(end)) { box.hidden = true; return; }
    var h = box.querySelector('[data-cd="h"]');
    var m = box.querySelector('[data-cd="m"]');
    var s = box.querySelector('[data-cd="s"]');
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0 && daily) { end = nextMidnight(); ms = end - Date.now(); }
      if (ms <= 0) { box.hidden = true; return false; }
      var t = Math.floor(ms / 1000);
      h.textContent = pad(Math.floor(t / 3600));
      m.textContent = pad(Math.floor(t % 3600 / 60));
      s.textContent = pad(t % 60);
      return true;
    }
    if (tick()) {
      var timer = setInterval(function () {
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }
 if (!tick()) clearInterval(timer); }, 1000);
    }
  });

  /* Product form: variant swatches, pack offer, prices and button label. */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var root = form.closest('[data-product-section]') || document;
    var sticky = document.querySelector('[data-stickybar]');
    var currency = form.getAttribute('data-currency') || 'USD';
    var noun = form.getAttribute('data-noun') || 'items';
    var singleLabel = form.getAttribute('data-single-label') || 'Add to cart';
    var packLabel = form.getAttribute('data-pack-label') || 'Add pack';
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    } catch (e) {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    function money(cents) { return fmt.format(cents / 100); }
    function set(selector, text) {
      root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
    }

    function render() {
      var variantInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!variantInput) { return; }
      var unit = parseInt(variantInput.getAttribute('data-unit'), 10);
      if (isNaN(unit)) { return; }
      var packTotal = unit * 2;
      var packEach = Math.round(packTotal / 3);
      var qtyInput = form.querySelector('input[name="quantity"]:checked');
      var isPack = qtyInput && qtyInput.value === '3';
      var title = variantInput.getAttribute('data-title');

      set('[data-price]', money(isPack ? packTotal : unit));
      root.querySelectorAll('[data-price-was]').forEach(function (el) {
        el.hidden = !isPack;
        if (isPack) { el.textContent = money(unit * 3); }
      });
      set('[data-price-note]', isPack ? tx('pack_note', { P: money(packEach) }, '3 pillows \u00b7 %P% each') : tx('single_note', {}, 'Per pillow'));
      set('[data-offer-single]', money(unit));
      set('[data-offer-pack-compare]', money(unit * 3));
      set('[data-offer-pack-price]', money(packTotal));
      set('[data-offer-pack-sub]', tx('pack_sub', { P: money(packEach), S: money(unit) }, '3 pillows \u00b7 %P% each \u00b7 You save %S%'));
      if (title) { set('[data-variant-name]', title); }

      var buy = form.querySelector('[data-buy]');
      var label = isPack ? packLabel : singleLabel;
      var total = isPack ? packTotal : unit;
      if (buy && !buy.disabled) { buy.textContent = label + ' · ' + money(total); }
      if (sticky) {
        var sp = sticky.querySelector('[data-sprice]');
        var sb = sticky.querySelector('[data-sbuy]');
        if (sp) { sp.textContent = money(total); }
        if (sb) { sb.textContent = label; }
      }
    }

    form.addEventListener('change', render);
    render();
  });


  /* Estimated delivery dates (business days from today). */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    if (isNaN(min) || isNaN(max)) { return; }
    function addBiz(n) {
      var d = new Date(), left = n;
      while (left > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { left--; } }
      return d;
    }
    try {
      var f = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
      var b = el.querySelector('b');
      if (b) { b.textContent = f.format(addBiz(min)) + ' \u2013 ' + f.format(addBiz(max)); }
    } catch (e) {}
  });

  /* Sticky buy bar on mobile: shown once the main buy button scrolls out of view. */
  var bar = document.querySelector('[data-stickybar]');
  var buyButton = document.querySelector('[data-buy]');
  if (bar && buyButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(buyButton);
  }

  /* Photo slider: arrows, thumbnails, counter and swipe (native scroll-snap). */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var counter = g.querySelector('[data-counter]');
    var total = slides.length;
    var current = 0;
    if (!track || total < 2) { return; }
    function go(i) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      current = i;
      if (counter) { counter.textContent = (i + 1) + ' / ' + total; }
      thumbs.forEach(function (t, n) {
        if (n === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      var box = thumbs[i] && thumbs[i].closest('[data-thumbs]');
      if (box && thumbs[i]) {
        var li = thumbs[i].parentNode;
        if (box.scrollHeight > box.clientHeight + 2) {
          box.scrollTo({ top: li.offsetTop - (box.clientHeight - li.offsetHeight) / 2, behavior: 'smooth' });
        } else if (box.scrollWidth > box.clientWidth + 2) {
          box.scrollTo({ left: li.offsetLeft - (box.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) { return; }
      raf = requestAnimationFrame(function () {
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }

        raf = null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { mark(i); }
      });
    });
    var prev = g.querySelector('[data-prev]');
    var next = g.querySelector('[data-next]');
    if (prev) { prev.addEventListener('click', function () { go(current === 0 ? total - 1 : current - 1); }); }
    if (next) { next.addEventListener('click', function () { go(current === total - 1 ? 0 : current + 1); }); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  });

  /* Announcement bar: hide the timed message once its end time passes. */
  document.querySelectorAll('[data-promo-end]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-promo-end'));
    if (!isNaN(end) && end <= Date.now()) {
      el.hidden = true;
      var sep = el.nextElementSibling;
      if (sep && sep.tagName === 'I') { sep.hidden = true; }
    }
  });

  /* Carousels (reviews): swipe, arrows, dots, pause button and automatic movement. */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dotsBox = root.querySelector('[data-dots]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var toggle = root.querySelector('[data-toggle]');
    if (!track || slides.length === 0) { return; }
    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var perView = 1, pages = 1, page = 0, timer = null;
    var hovering = false, userPaused = false, inView = true, resumeTimer = null;

    function measure() {
      if (!track.clientWidth || !slides[0].offsetWidth) { return false; }
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var pitch = slides[0].offsetWidth + gap;
      perView = Math.max(1, Math.round((track.clientWidth + gap) / pitch));
      var newPages = Math.max(1, Math.ceil(slides.length / perView));
      if (newPages !== pages || (dotsBox && dotsBox.children.length !== newPages)) { pages = newPages; buildDots(); }
      return true;
    }
    function buildDots() {
      if (!dotsBox) { return; }
      dotsBox.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        (function (n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', tx('go_to', { N: n + 1 }, 'Go to review group %N%'));
          b.addEventListener('click', function () { go(n); bump(); });
          dotsBox.appendChild(b);
        })(i);
      }
      markDot();
    }
    function markDot() {
      if (!dotsBox) { return; }
      Array.prototype.forEach.call(dotsBox.children, function (b, i) {
        if (i === page) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
      });
    }
    function go(n) {
      measure();
      page = ((n % pages) + pages) % pages;
      var target = slides[Math.min(page * perView, slides.length - 1)];
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      markDot();
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) { return; }
      raf = requestAnimationFrame(function () {
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }

        raf = null;
        var nearest = 0, best = Infinity;
        slides.forEach(function (sl, i) {
          var d = Math.abs(sl.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = i; }
        });
        var p = Math.min(pages - 1, Math.round(nearest / perView));
        if (p !== page) { page = p; markDot(); }
      });
    });

    function running() { return interval > 0 && !userPaused && !hovering && inView && !document.hidden && pages > 1; }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!interval) { return; }
      timer = setInterval(function () {
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }

        measure();
        if (running()) { go(page + 1); }
      }, interval);
    }
    function bump() { if (!userPaused) { start(); } }
    function setToggle() {
      if (!toggle) { return; }
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? tx('play', {}, 'Play automatic movement') : tx('pause', {}, 'Pause automatic movement'));
      toggle.classList.toggle('is-paused', userPaused);
    }

    if (prev) { prev.addEventListener('click', function () { go(page - 1); bump(); }); }
    if (next) { next.addEventListener('click', function () { go(page + 1); bump(); }); }
    if (toggle) {
      if (!interval) { toggle.hidden = true; }
      toggle.addEventListener('click', function () { userPaused = !userPaused; setToggle(); if (!userPaused) { start(); } });
      setToggle();
    }
    root.addEventListener('mouseenter', function (e) { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    root.addEventListener('touchstart', function () { hovering = true; clearTimeout(resumeTimer); }, { passive: true });
    root.addEventListener('touchend', function () { clearTimeout(resumeTimer); resumeTimer = setTimeout(function () {
  var T = window.DROWSA_T || {};
  function tx(key, vars, fallback) {
    var str = T[key] || fallback || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  }
 hovering = false; }, 4000); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; if (inView) { measure(); } }, { threshold: 0.15 }).observe(root);
    }
    window.addEventListener('resize', function () { measure(); go(Math.min(page, pages - 1)); });
    window.addEventListener('load', function () { measure(); });

    measure(); buildDots(); start();
  });

  /* Home: show the sticky buy bar once the hero button has scrolled away (mobile). */
  var homeBar = document.querySelector('[data-home-sticky]');
  var heroCta = document.querySelector('[data-hero-cta]');
  if (homeBar && heroCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      homeBar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(heroCta);
  }

  /* Gentle scroll reveal. Elements are only hidden after this script marks them. */
  if ('IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var targets = document.querySelectorAll('.hero-copy, .hero-shot, .benefits li, .ps-section > *, .offer-banner > *, .feature, .compare-wrap, .rv, .faq, .closing, .block > h2');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { return; }
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  }

  /* Reviews row: pause / play button. */
  document.querySelectorAll('[data-rv-toggle]').forEach(function (btn) {
    var row = btn.closest('.rv-tools');
    var target = row && row.previousElementSibling;
    if (!target || !target.hasAttribute('data-rv-marquee')) { target = document.querySelector('[data-rv-marquee]'); }
    btn.addEventListener('click', function () {
      var paused = target.classList.toggle('is-paused');
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? tx('play', {}, 'Play automatic movement') : tx('pause', {}, 'Pause automatic movement'));
    });
  });
})();
